import React from 'react'

const Counter = () => {
    return (
        <div>
             {/* <!-- Counters strat --> */}
            <div className="counters">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="counter-box">
                                <i className="flaticon-car"></i>
                                <h1 className="counter">97</h1>
                                <h5>Total Importaciones</h5>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="counter-box">
                                <i className="flaticon-blog"></i>
                                <h1 className="counter">126</h1>
                                <h5>Comentarios positivos</h5>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="counter-box">
                                <i className="flaticon-user"></i>
                                <h1 className="counter">396</h1>
                                <h5>Clientes Felices</h5>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6">
                            <div className="counter-box">
                                <i className="flaticon-medal"></i>
                                <h1 className="counter">17</h1>
                                <h5> Reconocimientos y distintivos</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Counters end --> */}            
        </div>
    )
}

export default Counter


// WEBPACK FOOTER //
// ./src/components/Counter.jsx